// extracted by mini-css-extract-plugin
export default {"card":"Card_Order_card__VdXoN","quantity":"Card_Order_quantity__JGwPc","left":"Card_Order_left__5Fuup"};